import type { NoteDetail } from '@kartothek/shared';
import { useTypes } from '../hooks';
import { t } from '../i18n';
import { NoteLink } from './NoteLink';

export function Backlinks({ note }: { note: NoteDetail }) {
  const types = useTypes(note.campaignId);
  const { linked, mentions } = note.backlinks;
  return (
    <section className="backlinks">
      <h3>
        {t('note.backlinks')} <span className="count">{linked.length}</span>
      </h3>
      {linked.length === 0 && <p className="muted">{t('note.noBacklinks')}</p>}
      <ul>
        {linked.map((b) => (
          <li key={b.id}>
            <span className="type-dot" style={{ background: types.byKey.get(b.typeKey)?.color }} />
            <NoteLink cid={note.campaignId} noteId={b.id}>
              {b.title}
            </NoteLink>
            {b.properties?.map((key) => (
              <span key={key} className="relation-tag" title={t('note.viaProperty')}>
                {types.byKey.get(b.typeKey)?.fields.find((f) => f.key === key)?.label ?? key}
              </span>
            ))}
            {b.folder && <span className="muted small"> · {b.folder}</span>}
          </li>
        ))}
      </ul>
      {mentions.length > 0 && (
        <>
          <h3>
            {t('note.mentions')} <span className="count">{mentions.length}</span>
          </h3>
          <ul>
            {mentions.map((b) => (
              <li key={b.id}>
                <span className="type-dot" style={{ background: types.byKey.get(b.typeKey)?.color }} />
                <NoteLink cid={note.campaignId} noteId={b.id}>
                  {b.title}
                </NoteLink>
                {b.snippet && <div className="snippet muted small">{b.snippet}</div>}
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
